// The one persistent link below the left panel that still leaves the campaign. Its URL
// hardcodes `en-us` like back-market.translations.ts (the app is fixed to the US market).
//
// Sources, Contributors and Press kit used to sit here as docs.google.com placeholders;
// they are now documents this app renders in an `ExtendedModal`, so their labels live
// beside their ids in `data/footer-docs.ts` — the modal titles itself with the same word
// the link carries.
export default {
  legalUrl: {
    id: 'rm_footer_legal_url',
    defaultMessage: 'https://www.backmarket.com/en-us/legal/legal-mentions',
  },
  legalLabel: {
    id: 'rm_footer_legal_label',
    defaultMessage: 'Legal Mentions',
  },
} as const
